import { render, staticRenderFns } from "./morelist.vue?vue&type=template&id=6b9d8127&"
import script from "./morelist.vue?vue&type=script&lang=js&"
export * from "./morelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports